<div class="container-fluid">
    <div class="row caja">
        <mat-radio-group [(ngModel)]="selectedFilter" (change)="cargarData()">
            <mat-radio-button value="quarter">Quarter</mat-radio-button>
            <mat-radio-button value="year">Year</mat-radio-button>
            <!-- Agrega más opciones de radio según sea necesario -->
        </mat-radio-group>
        <mat-form-field>
            <mat-label>Filter</mat-label>
            <input matInput (keyup)="applyFilter($event)" placeholder="Ex. ium" #input>
        </mat-form-field>
          <cdk-virtual-scroll-viewport itemSize="50" class="example-viewport">
          <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
            <ng-container matColumnDef="finalLink">
              <th mat-header-cell *matHeaderCellDef> Enlace Documento </th>
              <td mat-cell *matCellDef="let element"> <a href="{{element.finalLink}}" target="_blank" rel="noopener noreferrer">{{element.finalLink}}</a>
              </td>
            </ng-container>
            <ng-container matColumnDef="period">
              <th mat-header-cell *matHeaderCellDef> Periodo </th>
              <td mat-cell *matCellDef="let element"> {{element.period}} </td>
            </ng-container>
            <ng-container matColumnDef="date">
                <th mat-header-cell *matHeaderCellDef> Fecha del Periodo </th>
                <td mat-cell *matCellDef="let element"> {{element.date}} </td>
              </ng-container>
            <!-- Symbol Column -->
            <ng-container matColumnDef="fillingDate">
              <th mat-header-cell *matHeaderCellDef> Fecha Presentacion </th>
              <td mat-cell *matCellDef="let element"> {{element.fillingDate}} </td>
            </ng-container>
          
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          
            <!-- Row shown when there is no matching data. -->
            <tr class="mat-row" *matNoDataRow>
              <td class="mat-cell" colspan="4">No data matching the filter "{{input.value}}"</td>
            </tr>
          </table>
        </cdk-virtual-scroll-viewport>
    </div>
</div>
